
import API from '@services/API';

import { setError, startSpinner, stopSpinner } from '../common/actionCreators';

import { configs } from '@constants/configs/configs';

const {
    DOCUMENTS_VERIFICATION_DATA,
    OVERRIDE_DOCUMENTS,
    REMOVE_UPLOADED_DOCUMENT,
    SUBMIT_DOCUMENTS,
    UPLOAD_VERIFICATION_DOCUMENT,
    UPLOADED_DOCUMENT_URL
} = configs.endpoints;


const actions = { setError, startSpinner, stopSpinner };

export const fetchVerificationDocuments = (caseNumber, stateCode) => async dispatch => {
    return await API.getData(
        DOCUMENTS_VERIFICATION_DATA.processReplacements({ caseNumber, stateCode }),
        dispatch,
        actions
    );
};

export const removeDocument = payload => async dispatch => {
    return await API.postData(
        [
            REMOVE_UPLOADED_DOCUMENT,
            payload
        ],
        dispatch,
        actions
    );
};

export const uploadDocument = formData => async dispatch => {
    return await API.postData(
        [
            UPLOAD_VERIFICATION_DOCUMENT,
            formData,
            undefined,
            undefined,
            undefined,
            'multipart/form-data'
        ],
        dispatch,
        actions
    );
};

export const submitDocuments = payload => async dispatch => {
    return await API.postData(
        [
            SUBMIT_DOCUMENTS,
            payload
        ],
        dispatch,
        actions
    );
};

export const overrideDocuments = payload => async dispatch => {
    return await API.postData(
        [
            OVERRIDE_DOCUMENTS,
            payload
        ],
        dispatch,
        actions
    );
};

export const viewUploadedDocument = encryptedDocumentPath => async dispatch => {
    return await API.getData(
        UPLOADED_DOCUMENT_URL.processReplacements({ encryptedDocumentPath }),
        dispatch,
        actions,
        undefined,
        undefined,
        true
    ).then(async response => {
        const blob = await response.blob();
        return window.URL.createObjectURL(blob);
    });
};